import { Language } from '^/types';

export default {
  userRolesAndPermissions: {
    [Language.EN_US]: 'User Roles & Permissions',
    [Language.KO_KR]: '사용자 역할 및 권한',
  },
  confirm: {
    [Language.EN_US]: 'Confirm',
    [Language.KO_KR]: '확인',
  },
};
